import videojs from 'video.js'
import 'videojs-contrib-ads'
import 'video.js/dist/video-js.css'
import 'videojs-youtube'
// Import videojs-http-streaming if not already imported by video.js
// This might be imported automatically with video.js in newer versions
// Uncomment if needed: import 'videojs-http-streaming'

document.addEventListener('DOMContentLoaded', function () {
  // Initialize video.js player with HLS support
  const player = videojs('videoPlayer', {
    techOrder: ['vimeo', 'youtube', 'html5'],
    autoplay: false,
    controls: true,
    muted: false, // Ensure audio is on by default
    html5: {
      hls: {
        overrideNative: true, // Use videojs-http-streaming instead of native HLS
        enableLowInitialPlaylist: false // Start with higher quality
      }
    }
  })

  // Add the videojs-quality-selector plugin if it exists (optional enhancement)
  // if (videojs.getPlugin('qualityLevels')) {
  //   player.qualityLevels();
  // }

  const baseUrl = document.querySelector('meta[name="baseUrl"]').getAttribute('content')
  const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content')
  let isVideoLoaded = false
  let currentVideoUrl = ''
  let isWatchHistorySaved = false

  async function CheckDeviceType() {
    try {
      const response = await fetch(`${baseUrl}/check-device-type`)
      const data = await response.json()
      return data.isDeviceSupported
    } catch (error) {
      return false
    }
  }

  async function checkAuthenticationAndDeviceSupport() {
    const isDeviceSupported = await CheckDeviceType()
    return isAuthenticated && isDeviceSupported
  }

  async function loadVideoIfAuthenticated() {
    const accessType = document.querySelector('#videoPlayer').getAttribute('data-movie-access')

    // if (!isAuthenticated) {
    //   return // Exit if not authenticated
    // }

    let canPlay = true
    if (accessType === 'paid') {
      canPlay = await checkAuthenticationAndDeviceSupport()
    }

    if (canPlay && !isVideoLoaded) {
      const encryptedData = document.querySelector('#videoPlayer').getAttribute('data-encrypted')
      const watchTime = document.querySelector('#videoPlayer').getAttribute('data-watch-time')

      let watchTimeInSeconds = 0
      if (watchTime) {
        const [hours, minutes, seconds] = watchTime.split(':').map(Number)
        watchTimeInSeconds = hours * 3600 + minutes * 60 + seconds
      }

      fetch(`${baseUrl}/video/stream/${encodeURIComponent(encryptedData)}`)
        .then((response) => response.json())
        .then((data) => {
          const qualityOptions = data.qualityOptions
          setVideoSource(player, data.platform, data.videoId, data.url, data.mimeType, qualityOptions)
          player.load()
          player.one('loadedmetadata', async function () {
            player.currentTime(watchTimeInSeconds)
            player.muted(false) // Make sure audio is on by default
            try {
              await player.play()
            } catch (error) {
              console.error('Error trying to autoplay:', error)
            }
          })
          isVideoLoaded = true
        })
        .catch((error) => console.error('Error fetching video:', error))
    } else {
      $('#DeviceSupport').modal('show')
    }
  }

  loadVideoIfAuthenticated()

  const playButton = document.querySelector('.vjs-big-play-button')
  if (playButton) {
    playButton.addEventListener('click', async function (e) {
      if (!isAuthenticated) {
        e.preventDefault() // Prevent play
        window.location.href = loginUrl // Redirect to login
      } else {
        const canPlay = await checkAuthenticationAndDeviceSupport()
        if (!canPlay) {
          e.preventDefault() // Prevent play if conditions are not met
        }
      }
    })
  }

  const handleWatchButtonClick = async (button, isSeasonWatch = false) => {
    const accessType = button.getAttribute('data-movie-access')
    const qualityOptionsData = button.getAttribute('data-quality-options')
    let qualityOptions = []

    // Parse quality options if available
    if (qualityOptionsData && qualityOptionsData !== 'null' && qualityOptionsData !== '') {
      try {
        qualityOptions = Object.entries(JSON.parse(qualityOptionsData)).map(([label, url]) => ({ label, url }))
      } catch (error) {
        console.error('Error parsing quality options:', error)
      }
    }

    const videoUrl = button.getAttribute('data-video-url')
    currentVideoUrl = videoUrl

    window.scrollTo({ top: 0, behavior: 'smooth' })

    fetch(`${baseUrl}/api/continuewatch-list`)
      .then((response) => response.json())
      .then(async (data) => {
        const entertainmentId = button.getAttribute('data-entertainment-id')
        const entertainmentType = button.getAttribute('data-entertainment-type')
        const matchingVideo = data.data.find((item) => item.entertainment_id === parseInt(entertainmentId) && item.entertainment_type === entertainmentType)
        let lastWatchedTime = 0
        if (matchingVideo && matchingVideo.total_watched_time) {
          lastWatchedTime = timeStringToSeconds(matchingVideo.total_watched_time)
        }

        if (accessType === 'paid') {
          const canPlay = await checkAuthenticationAndDeviceSupport()
          if (!canPlay) {
            player.pause()
            $('#DeviceSupport').modal('show') // Show device support modal if not supported
            return // Stop further execution
          }
        }

        if (accessType === 'free') {
          playVideo(videoUrl, qualityOptions, lastWatchedTime)
        } else {
          handleSubscription(button, videoUrl, qualityOptions, lastWatchedTime)
        }
      })
      .catch((error) => console.error('Error fetching continue watch:', error))

    isWatchHistorySaved = false // Reset flag
  }

  const watchNowButton = document.getElementById('watchNowButton')
  const seasonWatchBtn = document.getElementById('seasonWatchBtn')

  if (watchNowButton) {
    watchNowButton.addEventListener('click', async function (e) {
      e.preventDefault()
      if (!isAuthenticated) {
        window.location.href = loginUrl // Redirect to login if not authenticated
        return // Stop further execution
      }
      await handleWatchButtonClick(watchNowButton)
    })
  }
  const buttons = document.querySelectorAll('.season-watch-btn')

  buttons.forEach((button) => {
    button.addEventListener('click', async function (e) {
      e.preventDefault()
      if (!isAuthenticated) {
        window.location.href = loginUrl // Redirect to login if not authenticated
        return // Stop further execution
      }
      await handleWatchButtonClick(button)
    })
  })

  function playVideo(videoUrl, qualityOptions, lastWatchedTime) {
    const datatype = watchNowButton?.getAttribute('data-type') || seasonWatchBtn?.getAttribute('data-type')

    if (datatype === 'Local') {
      const videoSource = document.querySelectorAll('#videoSource')

      videoSource.src = videoUrl

      const videoPlayer = videojs('videoPlayer')
      videoPlayer.src({ type: 'video/mp4', src: videoUrl })
      videoPlayer.load()
      videoPlayer.play()

      // Always create quality selector for local videos if options exist
      if (qualityOptions && qualityOptions.length > 0) {
        createQualitySelector(qualityOptions)
      }
    } else {
      fetch(`${baseUrl}/video/stream/${encodeURIComponent(videoUrl)}`)
        .then((response) => response.json())
        .then((data) => {
          setVideoSource(player, data.platform, data.videoId, data.url, data.mimeType, qualityOptions)
          player.load()
          player.one('loadedmetadata', async function () {
            const isDeviceSupported = await CheckDeviceType()
            if (isDeviceSupported) {
              player.currentTime(lastWatchedTime)
              player.muted(false) // Make sure audio is on
              try {
                await player.play() // Attempt to autoplay
              } catch (error) {
                console.error('Error trying to autoplay:', error)
              }
            }
          })
        })
        .catch((error) => console.error('Error playing video:', error))
    }
  }

  // For HLS streams, detect quality levels and create selector
  function setupHLSQualitySelector(player) {
    // Wait for quality levels to be available
    player.on('loadedmetadata', function () {
      // Check if qualityLevels plugin is available
      if (player.qualityLevels && typeof player.qualityLevels === 'function') {
        const qualityLevels = player.qualityLevels()

        if (qualityLevels && qualityLevels.length > 1) {
          // Create a quality selector UI
          const qualitySelector = document.createElement('div')
          qualitySelector.classList.add('vjs-quality-selector')

          const qualityButton = document.createElement('button')
          qualityButton.classList.add('vjs-menu-button', 'vjs-menu-button-popup', 'vjs-control', 'vjs-button')
          qualityButton.type = 'button'
          qualityButton.setAttribute('aria-haspopup', 'true')
          qualityButton.setAttribute('aria-expanded', 'false')

          const buttonContent = document.createElement('span')
          buttonContent.classList.add('vjs-icon-cog')
          buttonContent.textContent = 'Quality'

          qualityButton.appendChild(buttonContent)

          const menuContent = document.createElement('div')
          menuContent.classList.add('vjs-menu')

          const menuItems = document.createElement('ul')
          menuItems.classList.add('vjs-menu-content')

          // Add Auto option
          const autoItem = document.createElement('li')
          autoItem.classList.add('vjs-menu-item', 'vjs-selected')
          autoItem.textContent = 'Auto'
          autoItem.setAttribute('data-quality', 'auto')
          menuItems.appendChild(autoItem)

          // Add quality options
          for (let i = 0; i < qualityLevels.length; i++) {
            const level = qualityLevels[i]
            const height = level.height
            if (!height) continue

            const item = document.createElement('li')
            item.classList.add('vjs-menu-item')
            item.textContent = `${height}p`
            item.setAttribute('data-quality', i)
            menuItems.appendChild(item)

            // Track whether this quality is enabled
            level.enabled = true
          }

          // Handle quality selection
          menuItems.addEventListener('click', function (event) {
            if (event.target && event.target.hasAttribute('data-quality')) {
              const quality = event.target.getAttribute('data-quality')

              // Update selected class
              const items = menuItems.querySelectorAll('li')
              items.forEach((item) => item.classList.remove('vjs-selected'))
              event.target.classList.add('vjs-selected')

              // Set quality levels
              if (quality === 'auto') {
                // Enable all quality levels (auto mode)
                for (let i = 0; i < qualityLevels.length; i++) {
                  qualityLevels[i].enabled = true
                }
              } else {
                // Enable only the selected quality level
                for (let i = 0; i < qualityLevels.length; i++) {
                  qualityLevels[i].enabled = i === parseInt(quality)
                }
              }
            }
          })

          menuContent.appendChild(menuItems)
          qualityButton.appendChild(menuContent)
          qualitySelector.appendChild(qualityButton)

          // Add to control bar
          const controlBar = player.controlBar.el()
          controlBar.appendChild(qualitySelector)

          // Set up menu behavior
          qualityButton.addEventListener('click', function () {
            // Toggle menu visibility
            const expanded = qualityButton.getAttribute('aria-expanded') === 'true'
            qualityButton.setAttribute('aria-expanded', !expanded)
            menuContent.style.display = expanded ? 'none' : 'block'
          })

          // Hide menu on click outside
          document.addEventListener('click', function (event) {
            if (!qualitySelector.contains(event.target)) {
              qualityButton.setAttribute('aria-expanded', 'false')
              menuContent.style.display = 'none'
            }
          })
        }
      } else if (player.tech_ && player.tech_.hls) {
        // Fallback for if qualityLevels plugin is not available but HLS is
        const hls = player.tech_.hls

        if (hls.representations && hls.representations()) {
          const representations = hls.representations()

          if (representations.length > 1) {
            // Create manual quality selector
            const qualitySelector = document.createElement('div')
            qualitySelector.classList.add('vjs-quality-selector')

            const selectElement = document.createElement('select')
            selectElement.classList.add('vjs-quality-dropdown')

            // Add Auto option
            const autoOption = document.createElement('option')
            autoOption.value = 'auto'
            autoOption.textContent = 'Auto'
            autoOption.selected = true
            selectElement.appendChild(autoOption)

            // Add representation options
            representations.forEach((rep, index) => {
              if (rep.height) {
                const option = document.createElement('option')
                option.value = index
                option.textContent = `${rep.height}p`
                selectElement.appendChild(option)
              }
            })

            // Handle quality selection
            selectElement.addEventListener('change', function () {
              const value = this.value

              if (value === 'auto') {
                representations.forEach((rep) => rep.enabled(true))
              } else {
                const index = parseInt(value)
                representations.forEach((rep, i) => {
                  rep.enabled(i === index)
                })
              }
            })

            qualitySelector.appendChild(selectElement)
            player.controlBar.el().appendChild(qualitySelector)
          }
        }
      }
    })
  }

  // Extract the quality selector creation into a separate function for reuse
  function createQualitySelector(qualityOptions) {
    // Remove any existing quality selector
    const existingQualitySelector = document.querySelector('.vjs-quality-selector')
    if (existingQualitySelector) {
      existingQualitySelector.remove()
    }

    // Only create selector if we have options
    if (qualityOptions && qualityOptions.length > 0) {
      const qualitySelector = document.createElement('div')
      qualitySelector.classList.add('vjs-quality-selector')

      const qualityDropdown = document.createElement('select')

      // Add quality options to dropdown
      qualityOptions.forEach((option) => {
        const qualityOption = document.createElement('option')
        qualityOption.value = option.url.value
        qualityOption.innerText = option.label
        qualityOption.setAttribute('data-type', option.url.type)
        qualityDropdown.appendChild(qualityOption)
      })

      qualityDropdown.addEventListener('change', function () {
        const selectedQuality = this.value
        const dataType = this.selectedOptions[0].getAttribute('data-type')

        if (dataType === 'Local') {
          const videoSource = document.querySelectorAll('#videoSource')
          videoSource.src = selectedQuality

          const videoPlayer = videojs('videoPlayer')
          videoPlayer.src({ type: 'video/mp4', src: selectedQuality })
          videoPlayer.load()
          videoPlayer.play()
        } else {
          fetch(`${baseUrl}/video/stream/${encodeURIComponent(selectedQuality)}`)
            .then((response) => response.json())
            .then((data) => {
              if (data.platform === 'youtube') {
                player.src({ type: 'video/youtube', src: `https://www.youtube.com/watch?v=${data.videoId}` })
              } else if (data.platform === 'vimeo') {
                player.src({ type: 'video/vimeo', src: `https://vimeo.com/${data.videoId}` })
              } else if (data.platform === 'hls') {
                player.src({ type: 'application/x-mpegURL', src: data.url })
              } else if (data.platform === 'local') {
                player.src({ type: data.mimeType, src: data.url })
              } else if (data.platform === 'external') {
                player.src({ type: 'video/mp4', src: data.videoId })
              }

              player.load()
              player.play()
            })
            .catch((error) => console.error('Error playing video:', error))
        }
      })

      qualitySelector.appendChild(qualityDropdown)
      player.controlBar.el().appendChild(qualitySelector)
    }
  }

  function handleSubscription(button, videoUrl, qualityOptions, lastWatchedTime) {
    const planId = button.getAttribute('data-plan-id')
    fetch(`${baseUrl}/check-subscription/${planId}`)
      .then((response) => response.json())
      .then((data) => {
        if (data.isActive) {
          playVideo(videoUrl, qualityOptions, lastWatchedTime)
        } else {
          // Open the modal to show the user options for selecting or confirming a plan
          $('#DeviceSupport').modal('show')

          // Assuming you have a button inside the modal to proceed with payment
          document.querySelector('#confirmSubscriptionButton').addEventListener('click', function () {
            // Redirect to subscription plan after modal confirmation
            window.location.href = `${baseUrl}/subscription-plan`
          })
        }
      })
      .catch((error) => console.error('Error checking subscription:', error))
  }

  player.on('ended', async function () {
    if (isWatchHistorySaved) return

    const entertainmentId = watchNowButton?.getAttribute('data-entertainment-id') || seasonWatchBtn?.getAttribute('data-entertainment-id')
    const entertainmentType = watchNowButton?.getAttribute('data-entertainment-type') || seasonWatchBtn?.getAttribute('data-entertainment-type')
    const profileId = watchNowButton?.getAttribute('data-profile-id') || seasonWatchBtn?.getAttribute('data-profile-id')

    if (isAuthenticated && entertainmentId && entertainmentType && profileId) {
      const isDeviceSupported = await CheckDeviceType()
      if (!isDeviceSupported) {
        $('#DeviceSupport').modal('show')
        return
      }

      const watchHistoryData = {
        entertainment_id: entertainmentId,
        entertainment_type: entertainmentType,
        profile_id: profileId
      }

      fetch(`${baseUrl}/api/save-watch-content`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': csrfToken
        },
        body: JSON.stringify(watchHistoryData)
      })
        .then((response) => response.json())
        .then((data) => {
          isWatchHistorySaved = true
        })
        .catch((error) => console.error('Error saving watch history:', error))
    }
  })

  window.addEventListener('beforeunload', async function () {
    const entertainmentId = watchNowButton?.getAttribute('data-entertainment-id') || seasonWatchBtn?.getAttribute('data-entertainment-id')
    const entertainmentType = watchNowButton?.getAttribute('data-entertainment-type') || seasonWatchBtn?.getAttribute('data-entertainment-type')
    const EpisodeId = watchNowButton?.getAttribute('data-episode-id') || seasonWatchBtn?.getAttribute('data-episode-id')

    if (isAuthenticated && currentVideoUrl && entertainmentId && entertainmentType) {
      const currentTime = player.currentTime()
      const totalWatchedTime = new Date(currentTime * 1000).toISOString().substr(11, 8)

      fetch(`${baseUrl}/api/save-continuewatch`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': csrfToken
        },
        body: JSON.stringify({
          entertainment_id: entertainmentId,
          entertainment_type: entertainmentType,
          total_watched_time: totalWatchedTime,
          watched_time: totalWatchedTime,
          episode_id: EpisodeId,
          video_url: currentVideoUrl
        })
      })
        .then((response) => response.json())
        .then((data) => {
          // Success handling if needed
        })
        .catch((error) => console.error('Error saving continue watching:', error))
    }
  })

  function setVideoSource(player, platform, videoId, url = '', mimeType = '', qualityOptions = []) {
    if (platform === 'youtube') {
      player.src({ type: 'video/youtube', src: `https://www.youtube.com/watch?v=${videoId}` })
    } else if (platform === 'vimeo') {
      player.src({ type: 'video/vimeo', src: `https://vimeo.com/${videoId}` })
    } else if (platform === 'hls') {
      player.src({
        type: 'application/x-mpegURL',
        src: url
      })

      // Setup HLS quality selector which will automatically detect quality levels
      setupHLSQualitySelector(player)
    } else if (platform === 'local') {
      player.src({ type: mimeType, src: url })
    } else if (platform === 'external') {
      player.src({ type: 'video/mp4', src: videoId })
    }

    // Create quality selector for non-HLS formats if quality options provided
    if (platform !== 'hls' && qualityOptions && qualityOptions.length > 0) {
      createQualitySelector(qualityOptions)
    }
  }

  function timeStringToSeconds(timeString) {
    const [hours, minutes, seconds] = timeString.split(':').map(Number)
    return hours * 3600 + minutes * 60 + seconds
  }

  // Add some CSS for the quality selector
  const style = document.createElement('style')
  style.textContent = `
    .vjs-quality-selector {
      position: relative;
      margin-right: 10px;
      margin-left: 10px;
    }
    .vjs-quality-selector select,
    .vjs-quality-dropdown {
      background-color: rgba(43, 51, 63, 0.7);
      border: none;
      color: white;
      padding: 2px 5px;
      border-radius: 3px;
      font-size: 12px;
    }
    .vjs-menu {
      position: absolute;
      bottom: 100%;
      left: 0;
      background-color: rgba(43, 51, 63, 0.7);
      border-radius: 2px;
      margin-bottom: 5px;
      min-width: 75px;
      display: none;
    }
    .vjs-menu-content {
      list-style: none;
      padding: 0;
      margin: 0;
    }
    .vjs-menu-item {
      padding: 5px 10px;
      cursor: pointer;
      color: white;
      font-size: 14px;
    }
    .vjs-menu-item:hover {
      background-color: rgba(115, 133, 159, 0.5);
    }
    .vjs-menu-item.vjs-selected {
      background-color: rgba(115, 133, 159, 0.8);
    }
    .vjs-icon-cog:before {
      content: "⚙";
      font-size: 16px;
    }
  `
  document.head.appendChild(style)
})
